export default __webpack_public_path__ + "static/media/AI.65b8254e.png";